/*
 * @Description: 翻译
 * @Author: YOYO [792611446@qq.com]
 * @LastEditors: YOYO [792611446@qq.com]
 * @Date: 2022-09-06 13:59:21
 * @LastEditTime: 2024-01-23 15:00:36
*/
import Vue from 'vue'
import words from './lang.js'
// console.log(123456, words)
const keys = Object.keys(words);
// 提前缓存正则，避免重复执行消耗性能
const regExps = keys.reduce((acc, key) => {
  // 模板型键名
  if (key.indexOf('{0}') > -1) {
    const reg = new RegExp(key.replace('{0}', '(.+)'));
    acc.push({
      expression: reg,
      key,
    });
  }
  return acc;
}, []);
export function translate(el = document.body, lang = 'rus') {
  const kv = words;
  if (!el.querySelectorAll) {
    return;
  }
  const _trans = label => {
    const text = label?.trim?.();
    if (!text) {
      return label;
    }
    if (kv[text]?.[lang]) {
      return kv[text]?.[lang];
    }
    for (let index = 0; index < regExps.length; index++) {
      const regItem = regExps[index];
      const m = text.match(regItem.expression);
      if (m) {
        return kv[regItem.key][lang].replace('{0}', m[1]);
      }
    }
    return text;
  };
  [...el.querySelectorAll('*')].forEach(node => {
    // 不能直接修改node.innerText，会导致Vue响应式失效
    // node.innerText = kv[node.innerText?.trim?.()] || node.innerText;
    if ((node.nodeName === 'INPUT' && node.type === 'text') || (node.nodeName === 'INPUT' && node.type === 'password')) {
      node.value = _trans(node.value);
      node.placeholder = _trans(node.placeholder);
    }
    const textNodes = [...node.childNodes].filter(n => n.nodeType === 3);
    textNodes.forEach(textNode => {
      textNode.textContent = _trans(textNode.textContent);
    });
  });
}

const __patch__ = Vue.prototype.__patch__;
Vue.prototype.__patch__ = function() {
  const elm = __patch__.apply(this, arguments);
  let lang = localStorage.getItem('lang') || 'zh-CN'
  if (lang != 'zh-CN') {
	  translate(elm, lang)
  }
  // if (this.$store?.getters?.language) {
  //   translate(elm, this.$store?.getters?.language);
  // }
  return elm;
};